import Immutable from 'immutable';

import { Gender } from 'omni-common-ui';
import StudentGeneralInfo from './';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
      return [key, `${val}`];
    case 'gender':
      return [key, Gender.parse(val)];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

export const create = (data) =>
  new StudentGeneralInfo(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./domain/StudentGeneralInfo/create.js